<template>
  <div class="checkout-choose-plan-step">
    <plan-selector
      :loading="loading"
      :selectedPlan="selectedPlan"
      :plans="plans"
      @planChosen="planChosen"
    />
  </div>
</template>

<script>
import appboy from 'appboy-web-sdk'
import { getDefaultPlansInfo, getOfferConfig } from '@/config/remote.config'
import { mapState } from 'vuex'

export default {
  name: 'checkout-choose-plan-step',
  props: {
    offer: String,
    plan: Object
  },
  data: () => ({
    loading: true,
    selectedPlan: null,
    plans: []
  }),
  computed: {
    ...mapState({ accountId: state => state.user.accountId })
  },
  methods: {
    planChosen(plan) {
      this.selectedPlan = plan
      this.$emit('planChosen', plan)
    },
    loadPlansInfo(plansInfo) {
      this.plans = [...plansInfo.filter(plan => !plan.hideOnCheckoutFlow)]
      this.selectedPlan = this.plan
      if (!this.selectedPlan) {
        this.selectedPlan = this.plans.find(it => it.selected) || this.plans[0]
      }
      this.$emit('planChosen', this.selectedPlan)
      this.loading = false
    }
  },
  mounted() {
    appboy.logCustomEvent('Reached Plans Page')
  },
  created() {
    (async () => {
      if (this.offer) {
        try {
          const offerConfig = await getOfferConfig(this.offer)
          if (offerConfig.requiresCoupon && !this.$route.query.coupon) {
            this.$emit('invalidCoupon')
          }
          this.loadPlansInfo(offerConfig.plans)
        } catch (e) {
          const plansInfo = await getDefaultPlansInfo()
          this.loadPlansInfo(plansInfo)
        }
      } else {
        const plansInfo = await getDefaultPlansInfo()
        this.loadPlansInfo(plansInfo)
      }
    })()
  }
}
</script>
